"use client";
import { Divider } from '@develos/next-components';
import React, {  } from 'react';
import { VehicleRecordDetailsType } from '@/types';
import KeyValueContainer from './components/KeyValueContainer';
import AxelsTableContainer from './components/AxelsTableContainer';
import PhotosContainer from './components/PhotosContainer';
import AxesDistanceContainer from './components/AxesDistanceContainer';

type Props = {
  details: VehicleRecordDetailsType | undefined;
}

const VehicleDetails = ({ details }: Props) => {
    return (
        <div className="flex flex-col gap-3">
          {details &&  <>
            <PhotosContainer details={details}/>
            <KeyValueContainer details={details}/>
            <Divider/>
            <AxelsTableContainer details={details}/>
            <AxesDistanceContainer details={details}/>
          </>}
        </div>
    );
};

export default VehicleDetails;